import BaseAPI from './base'
/**
 * API xử lý lớp học
 */
class IGiaoDucCourseAPI extends BaseAPI {}

export default new IGiaoDucCourseAPI('v1/igiaoduc-courses', 'Course')
